import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import UpToDate from "src/components/UpToDate";
import ClientTimesheetTable from "./ClientTimesheetTable";
// import ClientIncompleteTimesheetTable from "./ClientIncompleteTimesheetTable";
import { fetchClientPlacements } from "../../reducers/ClientPlacementsReducer";
import LoadingSpinnerCover from "src/components/LoadingSpinnerCover";
import store from "../../store";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const ClientTimesheets = ({ pendingPlacements = [], isLoading, userToken }) => {
  const classes = useStyles();

  useEffect(() => {
    store.dispatch(fetchClientPlacements);
  }, []);

  var containsTimesheets = pendingPlacements.filter(
    (p) => p.timesheet && p.employee
  );

  // var noTimesheets = pendingPlacements.filter(
  //   (p) => !p.timesheet && p.employee
  // );

  var pendingTimesheets = containsTimesheets.filter(
    (p) => p.timesheet.clock_out_time
  );

  var pendingApprovalTimesheets = pendingTimesheets.filter(
    (p) => p.timesheet.client_approval_status === "Pending"
  );

  if (isLoading) {
    return <LoadingSpinnerCover />;
  }

  if (pendingApprovalTimesheets.length === 0) {
    return <UpToDate />;
  }

  return (
    <div>
      {!pendingApprovalTimesheets ||
      pendingApprovalTimesheets.length === 0 ? null : (
        <div className={classes.root}>
          <ClientTimesheetTable
            timesheets={pendingApprovalTimesheets}
            userToken={userToken}
            useStyles={useStyles}
            pendingPlacements={pendingPlacements}
          />
        </div>
      )}
      {/* {!incompleteTimesheets || incompleteTimesheets.length === 0 ? null : (
        <div className={classes.root}>
          <ClientIncompleteTimesheetTable
            timesheets={incompleteTimesheets}
            userToken={userToken}
            useStyles={useStyles}
            pendingPlacements={pendingPlacements}
          />
        </div>
      )} */}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    pendingPlacements: state.clientPlacementsReducer.pendingPlacements,
    isLoading: state.userPlacementsReducer.isLoading,
    userToken: state.userTokenReducer.userToken,
  };
}

export default connect(mapStateToProps)(ClientTimesheets);
